import axios from 'axios'
import qs from 'qs'
import router from '../router'
import https from './index'
import betterwe from '@/common/app-common.js'
// import { Toast } from 'vant'
// import router from "../router"
// 本地
// let baseURL = "http://tapi.gym3.com/"
// let baseURL = 'https://api3.gymcity.com.cn/'
let baseURL = 'https://api3t.gymcity.com.cn/'
let globalKeyString = ''
let isRefreshing = false
let retryRequests = []
window.online = false
if (
  location.href.indexOf('btvue.gymcity.com.cn') !== -1 &&
  location.href.indexOf('tbtvue.gymcity.com.cn') === -1
) {
  // 正式库
  baseURL = 'https://api3.gymcity.com.cn/'
  window.online = true
}
if (location.href.indexOf('tbtvue.gymcity.com.cn') > -1) {
  // 测试库
  if (
    location.href.indexOf('isPreTest1101') !== -1 ||
    sessionStorage.getItem('isPreTest1101')
  ) {
    // 模拟 预发环境 链接中携带isPreTest1101参数（配置资源位进） 或者 本地存储isPreTest1101为true
    sessionStorage.setItem('isPreTest1101', true)
    baseURL = 'https://api3t_bi.gymcity.com.cn/'
    // baseURL = 'https://api3.gymcity.com.cn/'
  } else {
    baseURL = 'https://api3t.gymcity.com.cn'
  }
}

// 综训馆转介活动服务（/api/referral/* 免会话直连）
let arenaBaseURL = 'https://t-arena.betterwestar.com'
if (
  location.href.indexOf('btvue.gymcity.com.cn') !== -1 &&
  location.href.indexOf('tbtvue.gymcity.com.cn') === -1
) {
  // 正式库
  arenaBaseURL = 'https://arena.betterwestar.com'
}

// 获取hash链接中的参数
const _getQuery = (val) => {
  const w = location.search.indexOf('?')
  const query = location.search.substring(w + 1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] == val) {
      return pair[1]
    }
  }
  return false
}

// 获取cookie的token
const _getCookie = (name = 'token') => {
  let res
  res =
    localStorage.getItem(name) ||
    sessionStorage.getItem(name) ||
    _getQuery(name)
  if (!res) {
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    let arr = document.cookie.match(reg)
    let cookieRes = arr && unescape(arr[2] || '')
    res = res || cookieRes
  }
  return res
}
//刷新token
async function refreshToken(config) {
  if (!isRefreshing) {
    isRefreshing = true
    try {
      let refresh_token = JSON.parse(
        _getCookie('appLoginInfo') || '{}'
      )?.refresh_token
      let params = {
        headerObj: {
          token: _getCookie('token')
        },
        refresh_token: refresh_token
      }
      let result = await https.postBaseAppWithHeader(
        'getAccessTokenByRefreshToken',
        params
      )
      if (result.data.code != 200) {
        isRefreshing = false
        return Promise.reject()
      }
      let token = result.data.data.token
      if (token) {
        console.log('====================================')
        console.log('刷新减脂营token', token)
        console.log('====================================')
        localStorage.setItem('token', token)
        sessionStorage.setItem('token', token)
        betterwe.updateAppToken(result.data.data)
      }
      // 已经刷新了token，将所有队列中的请求进行重试
      retryRequests.map((cb) => {
        cb()
      })
      // 重试完清空这个队列
      retryRequests = []
      // 这边不需要baseURL是因为会重新请求url，url中已经包含baseURL的部分了
      config.baseURL = ''
      if (config.method === 'post') {
        config.data = qs.parse(config.data)
        config.data.token = token
      } else {
        config.params.token = token
      }
      isRefreshing = false
      return Axios(config)
    } catch (error) {
      isRefreshing = false
    }
  } else {
    // 正在刷新token，返回一个未执行resolve的promise
    return new Promise((resolve) => {
      // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
      retryRequests.push(() => {
        config.baseURL = ''
        let token = _getCookie('token')
        if (config.method == 'post') {
          config.data = qs.parse(config.data)
          config.data.token = token
        } else {
          config.params.token = token
        }
        resolve(Axios(config))
      })
    })
  }
}
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
const Axios = axios.create({
  baseURL,
  timeout: 20000, // 超时限制
  // responseType: "json",
  //withCredentials: true,
  changeOrigin: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    // Origin: "*",
    // Referer: "*"
  }
})
const CancelToken = axios.CancelToken
const requestMap = new Map()

// 请求前置拦截器
Axios.interceptors.request.use(
  (config) => {
    /* 如果参数中携带headerObj, 则往请求头中添加参数 */
    if (config.data.headerObj) {
      // console.log("地方",config, config.data.headerObj);
      Object.assign(config.headers, config.data.headerObj)
      delete config.data.headerObj
    }
    if (config.params.headerObj) {
      delete config.params.headerObj
    }
    // 防重复提交
    const keyString = qs.stringify(
      Object.assign(
        {},
        {
          url: config.url,
          method: config.method
        },
        config.data
      )
    )
    globalKeyString = keyString
    if (requestMap.get(keyString)) {
      // console.log(keyString)
      // 取消当前请求
      config.cancelToken = new CancelToken((cancel) => {
        cancel('请不要频繁请求')
      })
      /*   setTimeout(() => {
          requestMap.delete(keyString)
        }, 300) */
    } else {
      requestMap.set(keyString, true)
    }
    Object.assign(config, {
      _keyString: keyString
    })
    if (
      (config.method === 'post' &&
        config.headers['Content-Type'].indexOf('application/json') < 0) ||
      config.method === 'put' ||
      config.method === 'delete'
    ) {
      // 序列化
      config.data = qs.stringify(config.data)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
// 返回响应拦截器
Axios.interceptors.response.use(
  async (res) => {
    // console.log('返回响应拦截器', res)
    // 重置requestMap
    const config = res.config
    requestMap.set(config._keyString, false)
    // 健萌token错误
    if (
      !sessionStorage.getItem('haveJmTokenErrorLog') &&
      (res.data.code == 10002 || res.data.status == 1002)
    ) {
      // console.log('健萌token错误', res.config)
      sessionStorage.setItem('haveJmTokenErrorLog', true)
      https.addAppElkLog(
        `健萌token错误：${JSON.stringify({
          url: res.config.url,
          token: res.config.params.token
        })}`
      )
    }
    //数字中台登录错误跳转
    if (
      res.data.code == 401 &&
      res.config.url.indexOf('member/StorageLogin') >= 0
    ) {
      router.push({ path: '/fatcamp/login' })
    }
    /* 抖音积分兑换未登录 */
    if (
      [401, 410000].includes(res.data.code) &&
      res.config.url.indexOf('api/v1/IntegralConversionCenter') >= 0
    ) {
      router.push({ path: '/integral-exchange/login' })
    }
    if (
      res.data.code == 500001 &&
      res.config.url.indexOf('api/v1/TonicPlanOperate') >= 0
    ) {
      betterwe.isLogin()
    }
    /* token失效 */
    if (
      https._isApp() &&
      config.url.indexOf('btapp.gymcity.com.cn') >= 0 &&
      res.data.code == 401000
    ) {
      return refreshToken(config)
    }
    /* RefreshToken失效  */
    if (
      https._isApp() &&
      config.url.indexOf('btapp.gymcity.com.cn/getAccessTokenByRefreshToken') >=
        0 &&
      res.data.code == 402000
    ) {
      betterwe.onAccountExit()
    }
    return res
  },
  (error) => {
    if (error.config) {
      requestMap.delete(error.config._keyString) // 是否要清空requestMap？
    }
    //404等问题可以在这里处理
    return Promise.reject(error)
  }
)

/**
 * @description
 * 请求
 * @param url
 * @param data
 * @param method
 */
const request = (url, data = {}, method = 'post', noToken = 0) => {
  let Public = {
    // 参数携带token
    token: data.noToken ? '' : data.token || _getCookie('token')
  }
  //中台接口加入storageToken
  if (url.indexOf('member/StorageLogin') >= 0) {
    Public.storage_token = localStorage.getItem('storageToken')
  }
  data = Object.assign({}, data, Public)
  const obj = {
    method,
    url,
    data: data,
    params: method.toUpperCase() === 'GET' && Object.assign({}, data, Public)
  }
  // 李静接口 headers 中携带 token
  if (url.indexOf('fat-loss-camp.gymcity.com.cn') >= 0) {
    obj.headers = {
      Authorization: 'Bearer ' + data.token, // GO
      token: data.token // JAVA
    }
  }
  return Axios(obj)
}

export { request, _getCookie, arenaBaseURL }
